
























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
  AttivitaRequest,
  DATE_FROM_NULL,
  DATE_TO_NULL,
} from "@/data/models/attivita.model";

import { AttivitaService } from "@/data/services/attivita.service";
import { date2Num } from "yellowfin-ui-lib";

@Component({})
export default class AttivitaSearch extends Vue {
  @Inject("AttivitaService") ativitaService!: AttivitaService;

  searchparam: AttivitaRequest;

  dal!: Date | undefined;
  al!: Date | undefined;

  @Prop() all: boolean | undefined;

  @Watch("all")
  onDataChange() {
    console.log("onDataChange");
    if (this.all) {
      this.reset();
    }
    this.search();
  }

  constructor() {
    super();
    this.searchparam = new AttivitaRequest();
  }

  get config() {
    const conf = process.env.VUE_APP_SEARCH;
    return conf ? JSON.parse(conf) : {};
  }

  beforeMount() {
    this.reset();
  }

  search() {
    if (this.al) {
      this.al.setHours(23);
      this.al.setMinutes(59);
    }
    this.searchparam.finedal = this.dal ? date2Num(this.dal) : DATE_FROM_NULL;

    this.searchparam.fineal = this.al ? date2Num(this.al) : DATE_TO_NULL;
    this.$emit("search", this.searchparam);
  }

  reset() {
    this.searchparam = new AttivitaRequest();
    const now = new Date();
    if (!this.all) {
      this.dal = new Date();
      this.al = new Date(
        now.getFullYear(),
        now.getMonth() + 2,
        1,
        23,
        59,
        0,
        0
      );
    } else {
      this.dal = undefined;
      this.al = undefined;
    }
    this.search();
  }
}
